module.exports = __webpack_public_path__ + "img/cyber_white.afbd3d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/cyber/cyber_white.png
// module id = MFd3
// module chunks = 1